import { __awaiter, __generator } from "tslib";
import React from 'react';
import { HeaderClass } from '../client/src/modules/_core/components/Header/Header';
import { PageHomeClass } from '../client/src/modules/_core/components/PageHome/PageHome';
import { mmParseQuery, mmReplaceMap, mmUid } from 'mm-ts-utils';
import { url } from '../client/src/modules/_core/url';
import { headerOnCloseHandler } from './tmsk-uc33/externals-fns/header-close-handler';
import { getClientConfig, getSessionThreadId, removeSessionThreadId, setSessionTheadId, } from '../client/src/modules/_core/utils/app-storage';
import { TextMessageClass } from '../client/src/modules/chat/components/Messages/TextMessage';
import { BUBBLE_MSG_TYPE_COMMAND, BubbleChannel, BubbleChannelClass, BUBBLE_MSG_TARGET_ORIGIN, } from '../client/src/modules/_core/components/BubbleChannel';
import { ChatMessage } from '../client/src/modules/chat/ChatMessage';
import { api } from '../client/src/modules/_core/utils/api-helpers';
import { createDebugLogger } from '../client/src/modules/_core/utils/app-utils';
import { Button } from 'reactstrap';
import { I18nMsgNs } from '../client/src/modules/_core/utils/i18n-helpers';
import { PageChatClass } from '../client/src/modules/_core/components/PageChat/PageChat';
import { HeartBeatClass } from '../client/src/modules/_core/components/HeartBeat';
import { mmParseUrl } from 'mm-ts-utils-client';
import { AppClass } from '../client/src/modules/_core/components/App/App';
import { dataLayerPush } from './tmsk-uc33/_externals-utils';
import { BaseChatMessage } from '../client/src/_library/domain-base/BaseChatMessage';
import { GOODBOT_USER_ID } from '../client/src/consts';
import cn from 'classnames';
import { config } from '../client/src/modules/_core/config';
import { BytesizeIcon } from '../client/src/modules/_core/components/BytesizeIcon';
import { PageStartClass } from "../client/src/modules/_core/components/PageStart/PageStart";
var debug = createDebugLogger('initialize-externals');
var initialDataThemeContains = function (needle) {
    var _a;
    if (needle === void 0) { needle = ''; }
    var cfg = getClientConfig();
    var value = (_a = cfg.INITIAL_DATA) === null || _a === void 0 ? void 0 : _a.theme; // is set in client-externals/config.json
    if (!value)
        return false;
    return "".concat(value).toLowerCase().includes(needle.toLowerCase());
};
var isYoungUseCase = function () {
    return initialDataThemeContains('young');
};
export var GENERIC_USER_ID = '00000000-0000-0000-0000-000000000000';
export var GENESYS_AGENT_USER_ID = '11111111-2222-3333-4444-555555555555';
export var initializeExternals = function () {
    //
    // PageHomeClass.renderer = () => null;
    /**
     * @param cmp
     * @param threadId
     * @param prevThreadId
     */
    PageChatClass.threadIdHandler = function (cmp, threadId, prevThreadId) {
        threadId !== prevThreadId && removeSessionThreadId();
        threadId && setSessionTheadId(threadId);
        // note: it is important to return void here... otherwise it will be considered
        // as break flow command
    };
    /**
     * @param cmp
     */
    PageHomeClass.getInitialRoute = function (cmp) {
        var threadId = getSessionThreadId();
        if (threadId) {
            return url.CHAT(threadId);
        }
        var cfg = getClientConfig();
        var hasOmniChannelData = !!(cfg === null || cfg === void 0 ? void 0 : cfg.omniChannelData);
        var startChat = cfg.startChat;
        var isWelcomeScreenOffByEnv = !cfg.welcomeScreen;
        var showWelcomeScreenOverride = cfg.welcomeScreenOverride === true;
        var skipWelcomePage = hasOmniChannelData || startChat || isWelcomeScreenOffByEnv;
        if (skipWelcomePage && !showWelcomeScreenOverride) {
            return url.CHAT();
        }
    };
    /**
     * @param cmp
     * @param initialData
     */
    PageHomeClass.onInitialDataHandler = function (cmp, initialData) {
        debug('todo fixme - save initial data...', initialData);
        // cmp.props.history.replace(url.CHAT());
    };
    /**
     * @param cmp
     */
    PageHomeClass.rendererMain = PageStartClass.rendererMain = function (cmp) {
        var Msg = I18nMsgNs('PageHome');
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "gaid-page-home__texts" },
                React.createElement("h1", null,
                    React.createElement(Msg, { id: "startWelcome" })),
                React.createElement("p", { dangerouslySetInnerHTML: { __html: cmp._tns('startWelcomeDesc') } })),
            React.createElement("div", { className: "gaid-page-home__buttonwrap" },
                React.createElement(Button, { color: "primary", onClick: function () {
                        cmp.onStartNewClick();
                        // https://docs.google.com/spreadsheets/d/1WDsoIs_v0Dc1sOASo0k0ugUbb2i7o3QaJj6NyZisKAQ/edit#gid=0
                        dataLayerPush({
                            eventAction: 'RedButton',
                            eventLabel: 'Zacat Chat',
                        });
                    } },
                    React.createElement(Msg, { id: "startNew" })))));
    };
    /**
     *
     */
    HeaderClass.onCloseHandler = headerOnCloseHandler;
    /**
     * @param cmp
     */
    HeaderClass.rendererLeftBox = function (cmp) {
        if (isYoungUseCase()) {
            return null;
        }
        var cfg = getClientConfig();
        var headerCfg = cfg.HEADER || {};
        var LOGO_SRC_URL = cfg.LOGO_SRC_URL, PROJECT = cfg.PROJECT;
        // prioritu ma HEADER ale podporujeme aj staru notaciu
        LOGO_SRC_URL = headerCfg.LOGO_SRC_URL || LOGO_SRC_URL;
        // prettier-ignore
        return (React.createElement(React.Fragment, null, LOGO_SRC_URL && (React.createElement("img", { src: LOGO_SRC_URL, alt: "Logo", style: { /*width: '50px', marginLeft: '20px'*/} }))));
    };
    /**
     * @param cmp
     */
    HeaderClass.rendererMainBox = function (cmp) {
        var _a = cmp.props, headerLabel = _a.headerLabel, initialData = _a.initialData;
        // console.log(11111, headerLabel, initialData );
        // sane default if i18n is missing
        headerLabel = headerLabel || 'Online podpora';
        // UGLY HACK: ak sme na PageHome tak headerLabel este nemame... preto skusime
        // natvrdo takto:
        if (initialData) {
            // headerLabel sa setuje explictne
            var _map = {
                THDMOBIL: 'Technická podpora',
                THDFIX: 'Online podpora',
                ESALES: 'Online podpora',
                JURO: 'Online podpora',
            };
            var department_id = initialData.department_id;
            if (_map && department_id && _map[department_id]) {
                headerLabel = _map[department_id];
            }
        }
        if (isYoungUseCase()) {
            headerLabel = 'Slovak Telekom';
        }
        return React.createElement("strong", null, headerLabel);
    };
    HeaderClass.rendererRightBox = function (cmp) {
        var B = config.css.B('-header');
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { className: cn("".concat(B, "__boxbutton")), onClick: function (e) {
                    e.preventDefault();
                    BubbleChannel.postCommand(BubbleChannel.COMMAND_CLOSE);
                } },
                React.createElement(BytesizeIcon, { name: "minimize", size: "small", thickness: "medium" })),
            React.createElement("button", { className: cn("".concat(B, "__boxbutton fullscreen")), onClick: function (e) {
                    e.preventDefault();
                    BubbleChannel.postCommand(BubbleChannel.COMMAND_OPEN_FULLSCREEN_TOGGLE);
                    // BubbleChannel.postCommand(BubbleChannel.COMMAND_GET_STATE, null, console.log);
                } },
                React.createElement(BytesizeIcon, { name: "fullscreen", size: "small", thickness: "medium" })),
            React.createElement("button", { className: cn("".concat(B, "__boxbutton")), onClick: cmp._handleCloseClick }, cmp._renderCloseIcon())));
    };
    /**
     * @param cmp
     */
    // TextMessageClass.rendererAvatar = (cmp: TextMessageClass) => (
    //     <i data-author-type={cmp.props.message.authorType} />
    // );
    TextMessageClass.rendererAvatar = function (cmp) {
        var message = cmp.props.message;
        if (message.meta &&
            message.meta.agent_id &&
            message.user_id === GENESYS_AGENT_USER_ID) {
            var _url = mmParseUrl();
            var cfg = getClientConfig();
            var url_1 = mmReplaceMap(cfg.CHAT_API.URL, {
                '{protocol}': _url.protocol,
                '{hostname}': _url.hostname,
                '{port}': _url.port,
            });
            var avatarUrl = "".concat(url_1, "/agent/").concat(message.meta.agent_id, "/avatar");
            return (React.createElement("i", { "data-author-type": message.authorType },
                React.createElement("img", { src: avatarUrl, alt: "agent avatar" })));
        }
        return React.createElement("i", { "data-author-type": message.authorType });
    };
    TextMessageClass.messageTimestampFormatter = function (message, cmp) {
        var d = new Date(message.created);
        var pad = function (v) { return (v < 10 ? "0".concat(v) : v); };
        return pad(d.getHours()) + ':' + pad(d.getMinutes());
    };
    TextMessageClass.messageBodyMarkdownLinkRenderer = function (props) {
        var _a;
        var href = ((_a = props === null || props === void 0 ? void 0 : props.href) !== null && _a !== void 0 ? _a : '').toString();
        var target = /(telekom|juro)\.sk\//i.test(href) ? '_parent' : '_blank'; // naive...
        return (React.createElement("a", { href: href, target: target }, props.children));
    };
    /**
     * @param cmp
     * @param initialData
     */
    BubbleChannelClass.onInitialDataCustomHandler = function (cmp, initialData) { return __awaiter(void 0, void 0, void 0, function () {
        var messageData, result, bubbleMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // ak neposielame BC hack signal tak noop
                    if (!initialData._get_chat_status_asap) {
                        return [2 /*return*/];
                    }
                    messageData = {
                        id: mmUid(),
                        body: '__get_chat_status__' + JSON.stringify(initialData),
                    };
                    return [4 /*yield*/, api().saveMessage(messageData)];
                case 1:
                    result = _a.sent();
                    bubbleMessage = JSON.parse(result['chat_message']['__get_chat_status__']['body']);
                    debug('__get_chat_status__ response', bubbleMessage);
                    window.parent.postMessage({
                        type: BUBBLE_MSG_TYPE_COMMAND,
                        payload: bubbleMessage,
                    }, BUBBLE_MSG_TARGET_ORIGIN);
                    // return sometning just for the sake of convention... (this will end up
                    // as onSuccess response payload)
                    return [2 /*return*/, bubbleMessage];
            }
        });
    }); };
    /**
     * IMPORTANT: this should be more frequent than INACTIVE_CONVERSATIONS_GC_LIFETIME
     * on server
     * @param cmp
     */
    HeartBeatClass.getInterval = function (cmp) { return 10000; };
    /**
     * @param cmp
     */
    AppClass.renderer = function (cmp) {
        var initialData = cmp.props.initialData;
        var q = mmParseQuery();
        // UPDATE: nizsie vyhadzujem, lebo uz budeme pouzivat aj na webe...
        // https://trello.com/c/pAKH7CTr
        // parameter "auth" si nechavam ako lokalny test hack...
        // if (!isInIframe() && !(initialData || {} as any).headerAuthorization && !q.auth) {
        //     debug('Missing authorization header');
        //     return <div>Not authorized</div>;
        // }
        return void 0;
    };
    /**
     * @param m
     */
    ChatMessage.groupLabelResolver = function (m) {
        switch (m.user_id) {
            case GOODBOT_USER_ID:
                return 'bot';
            case GENESYS_AGENT_USER_ID:
                return 'agent';
            default:
                return 'user';
        }
    };
    /**
     * @param m
     */
    BaseChatMessage.authorTypeResolver = function (m) {
        if (m.user_id === GOODBOT_USER_ID || m.is_bot) {
            return 'bot';
        }
        if (m.user_id === GENESYS_AGENT_USER_ID) {
            return 'agent';
        }
        return 'user';
    };
};
